module.exports = require("@ember/owner");